import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import {formatCurrency,roundUpToHundreds} from '../utils';

Vue.use(Vuex)

const apiHellotecaProd = 'https://api.helloteca.com';
const apiHellotecaPre = 'https://api-dev-dot-helloteca-com.ew.r.appspot.com';
const apiHellotecaLocal = 'http://localhost:7999';
const xWebKeyProd = 'prod_public_3eTH95nz7urVNz8ADAInP5PeC3dv_nEfCHayPY5/4ZrUVMvmrw0VBR7bb';
const xWebKeyLocal = 'local_public_develop_team_HkaYN4bK5TszWY0EAJJUM';

/**LOCAL PRE-PRODUCTION O PRODUCTION VARS*/
const loc = decodeURIComponent(document.location.href);
const localhost = false;
//PRE,PRO,LOCAL
const entorno = (loc.lastIndexOf('localhost:') > 0 && localhost)?'LOCAL':((loc.lastIndexOf('pre-prescoring-myinvestor') > 0 || loc.lastIndexOf('localhost:') > 0)?'PRE':'PRO');
// webkey & url api
const xWebKey = entorno == 'LOCAL'? xWebKeyLocal : xWebKeyProd;
const apiHelloteca = entorno == 'PRE' ? apiHellotecaPre : (entorno == 'LOCAL'? apiHellotecaLocal : apiHellotecaProd);
/***********/

const vistaInicial = 'step_productos'; // empieza por step_productos - step_datos_financieros

export default new Vuex.Store({
    state: {
        currentStep: vistaInicial,
        stepsHistory: [vistaInicial], 
        headerTitle: 'Consigue la mejor hipoteca',
        headerSubtitle: 'Dentro o fuera de MyInvestor, qué más da.',
        gastos: {
            notaria: 2000,
            iva: 0.1
        },
        newTexts: {
            step_productos: [
                {
                    title: '¿Qué necesitas?',
                    explanation: ''
                }
            ],
            step_productos_helloteca: [
                {
                    title: '¿Qué necesitas?',
                    explanation: ''
                },
                {
                    title: '¿Dónde está la vivienda?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                }
            ],
            step_datos_vivienda:[
                {
                    title: '¿En qué parte del proceso te encuentras?',
                    explanation: ''
                },
                {
                    title: '¿Qué tipo de vivienda estás buscando?',
                    explanation: ''
                }
            ],
            step_datos_hipoteca_habitual: [
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Dónde está la vivienda?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                },
                {
                    title: '¿Cuánto dinero puedes aportar a la operación incluyendo impuestos?',
                    explanation: 'Te mostraremos el porcentaje de la relación entre el importe del préstamo y el valor de la vivienda (LTV)'
                }
            ],
            step_datos_hipoteca_2avivienda: [
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Dónde está la vivienda?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                },
                {
                    title: '¿Cuánto dinero puedes aportar a la operación incluyendo impuestos?',
                    explanation: 'Te mostraremos el porcentaje de la relación entre el importe del préstamo y el valor de la vivienda (LTV)'
                }
            ],
            step_datos_hipoteca_inversion: [
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Dónde está la vivienda?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                },
                {
                    title: '¿Cuánto dinero puedes aportar a la operación incluyendo impuestos?',
                    explanation: 'Te mostraremos el porcentaje de la relación entre el importe del préstamo y el valor de la vivienda (LTV)'
                }
            ],
            step_aval_habitual: [
                {
                    title: 'Con tu aportación, necesitamos un aval (propiedad propia o familiar sin cargas) como garantía. ¿Tienes uno?',
                    explanation: ''
                },
                {
                    title: '¿Quién te avala?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                },
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Tiene hipoteca la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Cuánto queda por pagar de la hipoteca?',
                    explanation: ''
                }
            ],
            step_aval_2avivienda: [
                {
                    title: 'Con los datos indicados, sólo te podemos ofrecer un producto si refuerzas la operación con alguna de estas opciones',
                    explanation: ''
                },
                {
                    title: '¿Quién te avala?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                },
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Tiene hipoteca la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Cuánto queda por pagar de la hipoteca?',
                    explanation: ''
                }
            ],
            step_aval_inversion: [
                {
                    title: 'Con los datos indicados, sólo te podemos ofrecer un producto si refuerzas la operación con alguna de estas opciones',
                    explanation: ''
                },
                {
                    title: '¿Quién te avala?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda'
                },
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Tiene hipoteca la vivienda?',
                    explanation: ''
                },
                {
                    title: '¿Cuánto queda por pagar de la hipoteca?',
                    explanation: ''
                }
            ],
            step_datos_hipoteca_mejora: [
                {
                    title: '¿Cuánto vale la vivienda?',
                    explanation: ''
                }, 
                {
                    title: '¿Dónde está la vivienda?',
                    explanation: 'Para calcular el Impuesto de Transmisiones Patrimoniales necesitamos la Provincia de la vivienda.'
                },
                {
                    title: '¿Cuánto te queda por pagar?',
                    explanation: ''
                },
                {
                    title: '¿Qué tipo de interés tienes?',
                    explanation: ''
                },
                {
                    title: '¿Cuánto tiempo te queda?',
                    explanation: ''
                }
            ],
            step_datos_titular: [
                {
                    title: 'Titulares de la operación',
                    explanation: ''
                },
                {
                    title: '¿Cuáles son tus ingresos mensuales?',
                    explanation: 'Indica todos los ingresos netos justificados en bancos y/o rentas incluyendo pagas prorrateadas, alquileres y variables'
                }
            ],
            step_datos_financieros: [
                {
                    title: '¿Tienes más de 50.000€ en productos de Inversión (Despósitos, acciones, fondos, planes de pensión, etc)?',
                    explanation: ''
                },
                {
                    title: '¿Tienes pensado realizar esta operación con un aval ICO?',
                    explanation: ''
                },
                {
                    title: '¿Tienes algún otro préstamo?',
                    explanation: ''
                },
                {
                    title: '',
                    explanation: 'Para calcular el ratio de endeudamiento de la operación, necesitamos conocer la suma de todas las cuotas mensuales de los préstamos o hipotecas que tengan los titulares.'
                },
                {
                    title: '¿Tienes alguna hipoteca o préstamo con MyInvestor?',
                    explanation: ''
                },
                {
                    title: '¿Eres cliente de MyInvestor?',
                    explanation: ''
                }
            ],
            step_datos_personales: [
                {
                    title: 'Déjanos tus datos',
                    explanation: 'Analizaremos tu operación y nos pondremos en contacto contigo para darte las opciones que mejor se ajusten a tus necesidades.'
                },
                {
                    label: 'Autorizo a MyInvestor y a Helloteca a intercambiar datos para que me proporcionen ofertas hipotecarias, inclusive de terceras entidades.'
                },
                {
                    label: 'Autorizo a recibir de MyInvestor y otras entidades del Grupo Andbank información sobre productos, servicios y promociones, inclusive por vía telemática.'
                },
                {
                    text: 'Los datos que nos facilites serán usados para comunicarse contigo o resolver consultas relacionadas con el producto. Puedes consultar nuestra Política de privacidad y ejercer tus derechos en protección de datos escribiendo a <a href="mailto:dpo@myinvestor.es">dpo@myinvestor.es</a>.'
                }
            ]
        },
        inputOptionsVariables: {
            producto: [
                {
                    "code": "habitual",
                    "name": "Comprar vivienda habitual",
                },
                {
                    "code": "2avivienda",
                    "name": "Comprar segunda vivienda",
                },
                {
                    "code": "inversion",
                    "name": "Compra para inversión",
                },
                {
                    "code": "mejorar",
                    "name": "Mejorar hipoteca actual",
                },
                {
                    "code": "otros",
                    "name": "Otros",
                }
            ],
            productos_helloteca: [
                {
                    code: "autopromocion",
                    name: "Autopromoción"
                },
                {
                    code: "ampliacion",
                    name: "Ampliación hipoteca"
                },
                {
                    code: "liquidez",
                    name: "Hipoteca liquidez"
                },
                {
                    code: "extincion_condominio",
                    name: "Extinción de condominio"
                },
                {
                    code: "cambio_vivienda",
                    name: "Cambio de vivienda"
                }
            ],
            estado_proceso:[
                {
                    code: "buscando",
                    name: "Busco información",
                },
                {
                    code: "comprar",
                    name: "Quiero saber viabilidad",
                },
                {
                    code: "escogida",
                    name: "Tengo vivienda escogida",
                },
                {
                    code: "arras",
                    name: "Tengo reserva / arras",
                }
            ],
            vivienda_nueva: [
                {
                    code: true,
                    name: "Obra nueva",
                },
                {
                    code: false,
                    name: "Segunda mano",
                }
            ],
            ccaa: [
                {
                    code: "no_specified",
                    name: "No especificada",
                    itp: 0.05,
                    ajd: 0.01
                },
                {
                    code: "andalucia",
                    name: "Andalucía",
                    itp: 0.08,
                    ajd: 0.012
                },
                {
                    code: "aragon",
                    name: "Aragón",
                    itp: 0.07,
                    ajd: 0.015
                },
                {
                    code: "asturias",
                    name: "Asturias",
                    itp: 0.08,
                    ajd: 0.012
                },
                {
                    code: "baleares",
                    name: "Baleares",
                    itp: 0.08,
                    ajd: 0.012
                },
                {
                    code: "canarias",
                    name: "Canarias",
                    itp: 0.065,
                    ajd: 0.0075
                },
                {
                    code: "cantabria",
                    name: "Cantabria",
                    itp: 0.08,
                    ajd: 0.003
                },
                {
                    code: "castillalamancha",
                    name: "Castilla la Mancha",
                    itp: 0.08,
                    ajd: 0.06
                },
                {
                    code: "castillaleon",
                    name: "Castilla León",
                    itp: 0.08,
                    ajd: 0.015
                },
                {
                    code: "cataluña",
                    name: "Cataluña",
                    itp: 0.10,
                    ajd: 0.015
                },
                {
                    code: "ceuta",
                    name: "Ceuta",
                    itp: 0.05,
                    ajd: 0.005
                },
                {
                    code: "navarra",
                    name: "Comunidad Foral de Navarra",
                    itp: 0.06,
                    ajd: 0.005
                },
                {
                    code: "valenciana",
                    name: "Comunidad Valenciana",
                    itp: 0.10,
                    ajd: 0.015
                },
                {
                    code: "extremadura",
                    name: "Extremadura",
                    itp: 0.08,
                    ajd: 0.015
                },
                {
                    code: "galicia",
                    name: "Galicia",
                    itp: 0.10,
                    ajd: 0.015
                },
                {
                    code: "larioja",
                    name: "La Rioja",
                    itp: 0.07,
                    ajd: 0.01
                },
                {
                    code: "madrid",
                    name: "Madrid",
                    itp: 0.06,
                    ajd: 0.0075
                },
                {
                    code: "melilla",
                    name: "Melilla",
                    itp: 0.06,
                    ajd: 0.005
                },
                {
                    code: "alava",
                    name: "País Vasco (Álava)",
                    itp: 0.04,
                    ajd: 0.025
                },
                {
                    code: "guipuzcoa",
                    name: "País Vasco (Guipúzcoa)",
                    itp: 0.04,
                    ajd: 0.01
                },
                {
                    code: "vizcaya",
                    name: "País Vasco (Vizcaya)",
                    itp: 0.04,
                    ajd: 0
                },
                {
                    code: "murcia",
                    name: "Región de Murcia",
                    itp: 0.08,
                    ajd: 0.015
                }
            ],
            provincias: [
                {
                    
                    code: "ES-VI",
                    name: "Araba/Álava",
                    ccaa: "alava"
                },
                {
                    code: "ES-AB",
                    name: "Albacete",
                    ccaa: "castillalamancha"
                },
                {
                    code: "ES-A",
                    name: "Alicante",
                    ccaa: "valenciana"
                },
                {
                    code: "ES-AL",
                    name: "Almería",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-AV",
                    name: "Ávila",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-BA",
                    name: "Badajoz",
                    ccaa: "extremadura"
                },
                {
                    code: "ES-PM",
                    name: "Illes Balears",
                    ccaa: "baleares"
                },
                {
                    code: "ES-B",
                    name: "Barcelona",
                    ccaa: "cataluña"
                },
                {
                    code: "ES-BU",
                    name: "Burgos",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-CC",
                    name: "Cáceres",
                    ccaa: "extremadura"
                },
                {
                    code: "ES-CA",
                    name: "Cádiz",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-CS",
                    name: "Castellón",
                    ccaa: "valenciana"
                },
                {
                    code: "ES-CR",
                    name: "Ciudad Real",
                    ccaa: "castillalamancha"
                },
                {
                    code: "ES-CO",
                    name: "Córdoba",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-C",
                    name: "Coruña",
                    ccaa: "galicia"
                },
                {
                    code: "ES-CU",
                    name: "Cuenca",
                    ccaa: "castillalamancha"
                },
                {
                    code: "ES-GI",
                    name: "Girona",
                    ccaa: "cataluña"
                },
                {
                    code: "ES-GR",
                    name: "Granada",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-GU",
                    name: "Guadalajara",
                    ccaa: "castillalamancha"
                },
                {
                    code: "ES-SS",
                    name: "Guipuzkoa",
                    ccaa: "guipuzcoa"
                },
                {
                    code: "ES-H",
                    name: "Huelva",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-HU",
                    name: "Huesca",
                    ccaa: "aragon"
                },
                {
                    code: "ES-J",
                    name: "Jaén",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-LE",
                    name: "León",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-L",
                    name: "Lleida",
                    ccaa: "cataluña"
                },
                {
                    code: "ES-LO",
                    name: "La Rioja",
                    ccaa: "larioja"
                },
                {
                    code: "ES-LU",
                    name: "Lugo",
                    ccaa: "galicia"
                },
                {
                    code: "ES-M",
                    name: "Madrid",
                    ccaa: "madrid"
                },
                {
                    code: "ES-MA",
                    name: "Málaga",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-MU",
                    name: "Murcia",
                    ccaa: "murcia"
                },
                {
                    code: "ES-NA",
                    name: "Navarra",
                    ccaa: "navarra"
                },
                {
                    code: "ES-OR",
                    name: "Ourense",
                    ccaa: "galicia"
                },
                {
                    code: "ES-O",
                    name: "Asturias",
                    ccaa: "asturias"
                },
                {
                    code: "ES-P",
                    name: "Palencia",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-GC",
                    name: "Las Palmas",
                    ccaa: "canarias"
                },
                {
                    code: "ES-PO",
                    name: "Pontevedra",
                    ccaa: "galicia"
                },
                {
                    code: "ES-SA",
                    name: "Salamanca",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-TF",
                    name: "S.C. Tenerife",
                    ccaa: "canarias"
                },
                {
                    code: "ES-S",
                    name: "Cantabria",
                    ccaa: "cantabria"
                },
                {
                    code: "ES-SG",
                    name: "Segovia",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-SE",
                    name: "Sevilla",
                    ccaa: "andalucia"
                },
                {
                    code: "ES-SO",
                    name: "Soria",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-T",
                    name: "Tarragona",
                    ccaa: "cataluña"
                },
                {
                    code: "ES-TE",
                    name: "Teruel",
                    ccaa: "aragon"
                },
                {
                    code: "ES-TO",
                    name: "Toledo",
                    ccaa: "castillalamancha"
                },
                {
                    code: "ES-V",
                    name: "Valencia",
                    ccaa: "valenciana"
                },
                {
                    code: "ES-VA",
                    name: "Valladolid",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-BI",
                    name: "Bizkaia",
                    ccaa: "vizcaya"
                },
                {
                    code: "ES-ZA",
                    name: "Zamora",
                    ccaa: "castillaleon"
                },
                {
                    code: "ES-Z",
                    name: "Zaragoza",
                    ccaa: "aragon"
                },
                {
                    code: "ES-CE",
                    name: "Ceuta",
                    ccaa: "ceuta"
                },
                {
                    code: "ES-ML",
                    name: "Melilla",
                    ccaa: "melilla"
                }
            ],
            aportacion_habitual: [
                {
                    code: 1,
                    name: "más de €",
                },
                {
                    code: 2,
                    name: "entre   € y   €",
                },
                {
                    code: 3,
                    name: "entre   € y   €",
                },
                {
                    code: 4,
                    name: "menos de €",
                }
            ],
            si_no:[
                {
                    code: true,
                    name: "Si",
                },
                {
                    code: false,
                    name: "No",
                },
            ],
            si_no_2avivienda:[
                {
                    code: true,
                    name: "Tengo otra vivienda libre de cargas propia o familiar",
                },
                {
                    code: false,
                    name: "Tengo fondos/valores por un importe superior a {{valor}} que puedo aportar o pignorar",
                    name_aux: "Tengo fondos/valores por un importe superior a {{valor}} que puedo aportar o pignorar"
                },
            ],
            si_no_inversion:[
                {
                    code: true,
                    name: "Tengo otra vivienda libre de cargas propia o familiar",
                },
                {
                    code: false,
                    name: "Tengo fondos/valores por un importe superior a {{valor}} que puedo aportar o pignorar",
                    name_aux: "Tengo fondos/valores por un importe superior a {{valor}} que puedo aportar o pignorar"
                },
            ],
            si_no_nose:[
                {
                    code: true,
                    name: "Si",
                },
                {
                    code: false,
                    name: "No",
                },
                {
                    code: null,
                    name: "No sé",
                }
            ],
            tipo_hipoteca:[
                {
                    code: "FIXED",
                    name: "Fijo"
                },
                {
                    code: "VARIABLE",
                    name: "Variable"
                }
            ],
            tipo_contrato: [
                {
                    code: "fijo",
                    name: "Fijo / Indefinido"
                },
                {
                    code: "fijo_discontinuo",
                    name: "Fijo discontinuo"
                },
                {
                    code: "funcionario",
                    name: "Funcionario"
                },
                {
                    code: "temporal",
                    name: "Temporal / Obra y Servicio"
                },
                {
                    code: "interino",
                    name: "Interino"
                },
                {
                    code: "autonomo_nomina",
                    name: "Autónomo con nómina"
                },
                {
                    code: "autonomo",
                    name: "Autónomo"
                },
                {
                    code: "rentista",
                    name: "Ingresos por rentas"
                },
                {
                    code: "pensionista_jubilado",
                    name: "Pensionista/Jubilado"
                },
                {
                    code: "siningresos",
                    name: "Sin ingresos"
                },
                {
                    code: "tuslabores",
                    name: "No trabaja"
                },
                {
                    code: "otro",
                    name: "Otro"
                }
            ],
            tipo_avalista: [
                { 
                    code: "propio", 
                    name: "Vivienda propia" 
                }, 
                { 
                    code: "padres", 
                    name: "Padres" 
                }, 
                { 
                    code: "pareja", 
                    name: "Pareja" 
                },  
                { 
                    code: "otros", 
                    name: "Otros" 
                }

            ]
        },
        titularBase: null, // base para titular
        dghBase: null, // base para DGH
        prescoringDataBase: null, // base para prescoringData
        prescoringData: {
            producto: null,
            estado_proceso: null,
            vivienda_nueva: null,
            precio_compra: null,
            ccaa: null,
            provincia: null,
            aportacion: null,
            titulares: [
                { 
                    numTitular: 0,
                    edad: null,
                    contrato: null,
                    antiguedad: null
                }
            ],
            total_ingresos: null,
            cliente_inversor: null,
            cliente_hipoteca_my: null,
            total_gastos: null,
            nombre: null, 
            apellidos: null,
            telefono: null,
            prefijo: null,
            email: null,
            utms: null,
            capital_pendiente: null,
            tipo_hipoteca_actual: null,
            tin_hipoteca_actual: null,
            anyos_hipoteca_actual: null,
            meses_hipoteca_actual: null,
            aval_ico: null,
            my_hello_check: false,
            my_andbank_check: false,
            dgh: {
                avalista: null,
                avalista_tipo: null,
                avalista_valor_vivienda: null,
                avalista_hipoteca: null,
                avalista_hipoteca_valor: null
            },
            prestamo: null,
            cliente_my: null,
            comentario: null
        },
        porcentajeHipoteca: 0
    },
    mutations: {
        // Steps
        updateCurrentStep(state, value){
            state.currentStep = value;
        },
        insertStepsHistory(state, value){
            state.stepsHistory.push(value);
        },
        extractStepsHistory(state){
            state.stepsHistory.pop();
        },
        updateHeaderTitle(state, newTitle) {
            state.headerTitle = newTitle;
        },
        updateHeaderSubtitle(state, newSubtitle) {
            state.headerSubtitle = newSubtitle;
        },
        // Objetos Base
        initObjetosBase(state){
            // prescoringData
            state.prescoringDataBase = JSON.parse(JSON.stringify(state.prescoringData));
            //console.log('Init Prescoring Data Base:', JSON.stringify(state.prescoringDataBase, null, 2));
            // titular
            state.titularBase = JSON.parse(JSON.stringify(state.prescoringData.titulares[0]));
            state.titularBase.numTitular = null;
            //console.log('Init Titular Base:', JSON.stringify(state.titularBase, null, 2));
            // dgh
            state.dghBase = JSON.parse(JSON.stringify(state.prescoringData.dgh));
            //console.log('Init Dgh Base:', JSON.stringify(state.dghBase, null, 2));
        },
        // Actualizar objeto prescoring
        resetPrescoringData(state){
            const utms = state.prescoringData.utms;
            state.prescoringData = JSON.parse(JSON.stringify(state.prescoringDataBase));
            state.prescoringData.utms = utms;
            //console.log('Reset:', JSON.stringify(state.prescoringData, null, 2));
        },
        resetProducto(state){
            state.prescoringData.producto = null;
            //console.log('Reset producto:', JSON.stringify(state.prescoringData, null, 2));
        },
        resetAportacion(state){
            state.prescoringData.aportacion = null;
            //console.log('Reset aportacion:', JSON.stringify(state.prescoringData, null, 2));
        },
        resetAvalista(state){
            state.prescoringData.dgh = {...state.dghBase};
            //console.log('Reset aportacion:', JSON.stringify(state.prescoringData, null, 2));
        },
        resetAvalistaHipotecaValor(state){
            state.prescoringData.dgh.avalista_hipoteca_valor = null;
            //console.log('Reset aportacion:', JSON.stringify(state.prescoringData, null, 2));
        },
        updatePrescoringData(state, { field, value }){
            state.prescoringData[field] = value;
            //console.log('PrescoringData:', JSON.stringify(state.prescoringData, null, 2));
        },
        updateDghField(state, {field, value}){
            state.prescoringData.dgh[field] = value;
            //console.log('PrescoringData:', JSON.stringify(state.prescoringData.dgh, null, 2));
        },
        updateTitularField(state, { titularIndex, field, value }) {
            state.prescoringData.titulares[titularIndex][field] = value;
            //console.log('PrescoringData:', JSON.stringify(state.prescoringData.titulares, null, 2));
        },
        addTitular(state, { titularIndex }) {
            const nuevoTitular = { ...state.titularBase };
            nuevoTitular['numTitular'] = titularIndex;
            state.prescoringData.titulares.push(nuevoTitular);
            //console.log('PrescoringData:', JSON.stringify(state.prescoringData.titulares, null, 2));
        },
        removeTitular(state) {
            state.prescoringData.titulares.pop();
            //console.log('PrescoringData:', JSON.stringify(state.prescoringData.titulares, null, 2));
        },
        setUTMParams(state, {utmParams}){
            state.prescoringData.utms = utmParams;
        },

        // Actualizar aportación
        updateAportacionHabitual(state, {idx, texto, precio_compra}){
            state.inputOptionsVariables.aportacion_habitual[idx]['code'] = precio_compra;
            state.inputOptionsVariables.aportacion_habitual[idx]['name'] = texto;
        },

        // Actualizar botón avalista
        updateBotonAvalista2aVivienda(state, {valor}){
            state.inputOptionsVariables.si_no_2avivienda[1]['name'] = state.inputOptionsVariables.si_no_2avivienda[1]['name_aux'].replace("{{valor}}", valor);
        },
        updateBotonAvalistaInversion(state, {valor}){
            state.inputOptionsVariables.si_no_inversion[1]['name'] = state.inputOptionsVariables.si_no_inversion[1]['name_aux'].replace("{{valor}}", valor);
        },

        // Actualizar cálculo porcentaje
        updatePorcentajeHipoteca(state, {valor}){
            state.porcentajeHipoteca = valor;
        }
    },
    actions: {
        setHeaderTitle({ commit }, title) {
            commit('updateHeaderTitle', title);
        },
        setHeaderSubtitle({ commit }, subtitle) {
            commit('updateHeaderSubtitle', subtitle);
        },
        
        // Steps
        goBack({ commit, state }) {
            if (state.stepsHistory.length > 1) {
                commit('extractStepsHistory');
                const lastRoute = state.stepsHistory[state.stepsHistory.length - 1];
                window.scrollTo(0, 0);
                commit('updateCurrentStep', lastRoute);
            }
            return null;
        },
        goNext({ commit }, next ){
            commit('insertStepsHistory', next);
            window.scrollTo(0, 0);
            commit('updateCurrentStep', next);
        },
        async calcularAportaciones2aVivienda({commit,dispatch,state}){
            // Variables
            const precio_compra = Number(state.prescoringData.precio_compra) || 0;
            const provincia = state.prescoringData.provincia || 'no_specified';
            const viviendaNueva = state.prescoringData.vivienda_nueva;
            const calculaImpuestos = true;
            // Calculamos gastos
            const gastos = await dispatch('calcularGastos',{precio_compra, provincia, viviendaNueva, calculaImpuestos});
            // Total con gastos
            const totalConGastos = precio_compra + gastos.total;
            // Obtenemos aportación según porcentaje
            const totalPorcentaje70 = precio_compra * 0.7;
            const aportacionTotal = totalConGastos - totalPorcentaje70;
            const aportacionMostrar = formatCurrency(roundUpToHundreds(Number(aportacionTotal)));
            commit('updateBotonAvalista2aVivienda', {valor: aportacionMostrar});
        },
        async calcularAportacionesInversion({commit,dispatch,state}){
            // Variables
            const precio_compra = Number(state.prescoringData.precio_compra) || 0;
            const provincia = state.prescoringData.provincia || 'no_specified';
            const viviendaNueva = state.prescoringData.vivienda_nueva;
            const calculaImpuestos = true;
            // Calculamos gastos
            const gastos = await dispatch('calcularGastos',{precio_compra, provincia, viviendaNueva, calculaImpuestos});
            // Total con gastos
            const totalConGastos = precio_compra + gastos.total;
            // Obtenemos aportación según porcentaje
            const totalPorcentaje70 = precio_compra * 0.7;
            const aportacionTotal = totalConGastos - totalPorcentaje70;
            const aportacionMostrar = formatCurrency(roundUpToHundreds(Number(aportacionTotal)));
            commit('updateBotonAvalistaInversion', {valor: aportacionMostrar});
        },
        async calcularAportacionesHabitual({commit,dispatch,state}){
            // Variables
            const precio_compra = Number(state.prescoringData.precio_compra) || 0;
            const provincia = state.prescoringData.provincia || 'no_specified';
            const viviendaNueva = state.prescoringData.vivienda_nueva;
            const calculaImpuestos = ['habitual','2avivienda'].includes(state.prescoringData.producto);
            // Calculamos gastos
            const gastos = await dispatch('calcularGastos',{precio_compra, provincia, viviendaNueva, calculaImpuestos});
            // Total con gastos
            const totalConGastos = precio_compra + gastos.total;
            // Obtenemos aportación según porcentaje
            let aportaciones = {};
            //80
            const totalPorcentaje80 = precio_compra * 0.8;
            aportaciones['80'] = totalConGastos - totalPorcentaje80;
            commit('updateAportacionHabitual', {idx:0, precio_compra: aportaciones['80'], texto: `Más de ${formatCurrency(roundUpToHundreds(Number(aportaciones['80'])))}`});
            //90
            const totalPorcentaje90 = precio_compra * 0.9;
            aportaciones['90'] = totalConGastos - totalPorcentaje90;
            commit('updateAportacionHabitual', {idx:1, precio_compra: aportaciones['90'], texto: `Entre ${formatCurrency(roundUpToHundreds(Number(aportaciones['80'])))} y ${formatCurrency(roundUpToHundreds(Number(aportaciones['90'])))}`});
            //90
            const totalPorcentaje100 = precio_compra;
            aportaciones['100'] = totalConGastos - totalPorcentaje100;
            commit('updateAportacionHabitual', {idx:2, precio_compra: aportaciones['100'], texto: `Entre ${formatCurrency(roundUpToHundreds(Number(aportaciones['90'])))} y ${formatCurrency(roundUpToHundreds(Number(aportaciones['100'])))}`});
            commit('updateAportacionHabitual', {idx:3, precio_compra: 0, texto: `Menos de ${formatCurrency(roundUpToHundreds(Number(aportaciones['100'])))}`});
            return aportaciones;
        },
        calcularGastos({state},params){
            // Variables para el cálculo
            const precio_compra = params.precio_compra;
            const provincia = params.provincia;
            const viviendaNueva = params.viviendaNueva;
            const calculaImpuestos = params.calculaImpuestos??false;
            // Init gastos y total gastos
            const gastos = {
                notaria: state.gastos.notaria
            };
            let totalGastos = state.gastos.notaria;
            const provinciaData = state.inputOptionsVariables.provincias.find(state => state.code === provincia);
            // Obtenemos información de la ccaa
            const ccaaData = provinciaData && provinciaData.ccaa ? state.inputOptionsVariables.ccaa.find(region => region.code === provinciaData.ccaa) : null;
            // Cálculo impuestos
            if(calculaImpuestos && ccaaData){
                // Vivienda nueva: ajd + iva
                if(viviendaNueva){
                    gastos['ajd'] = {
                        interes: ccaaData.ajd,
                        total: precio_compra * ccaaData.ajd
                    };
                    gastos['iva'] = {
                        interes: state.gastos.iva,
                        total: precio_compra * state.gastos.iva
                    };
                    totalGastos = totalGastos + gastos.ajd.total + gastos.iva.total;
                }
                // 2a Mano
                else{
                    gastos['itp'] = {
                        interes: ccaaData.itp,
                        total: precio_compra * ccaaData.itp
                    };
                    totalGastos = totalGastos + gastos.itp.total;
                }
            }
            gastos['total'] = totalGastos;            
            return gastos;
        },
        async calcularPorcentaje({commit, dispatch,state}){
            // Variables
            const precio_compra = Number(state.prescoringData.precio_compra) || 0;
            const provincia = state.prescoringData.provincia || 'no_specified';
            const viviendaNueva = state.prescoringData.vivienda_nueva;
            const aportacion = state.prescoringData.aportacion;
            const calculaImpuestos = ['habitual','2avivienda','inversion'].includes(state.prescoringData.producto);
            // Calculamos gastos
            const gastos = await dispatch('calcularGastos',{precio_compra, provincia, viviendaNueva, calculaImpuestos});
            // Total con gastos
            const totalConGastos = (precio_compra + gastos.total) - aportacion;
            // Obtenemos porcentaje
            const porcentaje = parseInt((totalConGastos / precio_compra) * 100);
            //console.log("datos: ",{totalConGastos: totalConGastos, porcentaje: porcentaje, precio_compra: precio_compra, provincia: provincia, viviendaNueva: viviendaNueva, aportacion: aportacion, gastos: gastos})
            commit('updatePorcentajeHipoteca', {valor: porcentaje});
            return porcentaje;
        },
        async registrarLead({ state }) {
            let params = state.prescoringData;
            params.telefono = String(params.prefijo) + String(params.telefono);
            delete params.prefijo;
            //if(!params.email.includes('+test@')) params.email = 'a+testfunnel@h.com';
            try {
                const response = await axios.post(
                    `${apiHelloteca}/public/funnel_myinvestor/leads`,
                    params,
                    { headers: 
                        {'Content-Type': 'application/json', 'X-WEB-KEY': xWebKey}
                    }
                );
                if (response.status) {
                    return response.data.data;
                } else {
                    console.log('Error en la respuesta de la API: ', response);
                }
            } catch (error) {
                console.error('Error en la llamada a la API:', error);
            }
        },
        registrarLeadBasico({ state }) {
            let params = state.prescoringData;
            params.telefono = String(params.prefijo) + String(params.telefono);
            delete params.prefijo;
            try {
                const response = axios.post(
                    `${apiHelloteca}/public/funnel_myinvestor/lead_basico`,
                    params,
                    { headers: 
                        {'Content-Type': 'application/json', 'X-WEB-KEY': xWebKey}
                    }
                );
                if (response.status) {
                    return response.data.data;
                } else {
                    console.log('Error en la respuesta de la API: ', response);
                }
            } catch (error) {
                console.error('Error en la llamada a la API:', error);
            }
        }
    },
});
